<div class="assessment-manager-list">
  <div class="header">
    <div>
      <h2>Assessment Manager</h2>
      <div class="subtitle" *ngIf="project">Project: {{project.name}}</div>
    </div>
    <div class="actions">
      <button pButton type="button" class="p-button-sm" icon="pi pi-plus" label="New Assessment"
              (click)="createAssessment()"></button>
      <button pButton type="button" class="p-button-text" label="Back to Project"
              (click)="backToProject()"></button>
    </div>
  </div>

  <p-table [value]="assessments" dataKey="assessmentId" [rows]="20" [paginator]="true" [rowsPerPageOptions]="[10,20,50]">
    <ng-template pTemplate="header">
      <tr>
        <th>Assessment Name</th>
        <th>Scope</th>
        <th>Period</th>
        <th>Lead</th>
        <th>Status</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td>{{item.assessmentName}}</td>
        <td>{{item.scopeSummary}}</td>
        <td>{{item.startDate | date:'shortDate'}} - {{item.endDate | date:'shortDate'}}</td>
        <td>{{item.lead?.fullName || item.lead?.emailAddress || '—'}}</td>
        <td>{{item.status === 0 ? 'Active' : 'Closed'}}</td>
        <td class="actions-cell">
          <button pButton type="button" class="p-button-text" icon="pi pi-eye" (click)="viewAssessment(item)"></button>
          <button pButton type="button" class="p-button-text" icon="pi pi-pencil" (click)="editAssessment(item)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
